/*
 * @Author: Dom
 * @Date: 2022-05-15 18:29:21
 * @LastEditTime: 2022-05-22 18:48:59
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\component\forgetpassword\locales\en-US.ts
 */
export default{
    'page.confirmtxt':'Determine',
    'page.ctrltxt':'Cancel',
    'page.btnchangetxt':'Change it',
    'page.verificationtxt':'Get verification code',
    'page.verificationtxtrepeat':'Retrieve verification code',
    'page.user.forgetpassword.email.tips':'Enter the email account that needs to retrieve the password',
    'page.user.forgetpassword.email.required':'Enter the correct email account',
    'page.user.forgetpassword.emailtitle':'Email retrieve password',
    'page.user.forgetpassword.phonetitle':'Mobile phone number retrieve password',
    'page.user.forgetpassword.sendemailstart.tips':'Please send email at',
    'page.user.forgetpassword.sendtime.tips':'60 minutes',
    'page.user.forgetpassword.sendemailend.tips':'go to the mailbox for verification within',
    'page.user.forgetpassword.sendemail.btntxt':'Send mail',
    'page.user.forgetpassword.phonenumber.tips':'Enter the binding mobile number',
    'page.user.forgetpassword.phonenumber.required':'Enter the correct mobile phone number',
    'page.user.forgetpassword.checknumber.tips':'Enter graphic verification code',
    'page.user.forgetpassword.checknumber.required':'Please enter the graphic verification code',
    'page.user.forgetpassword.msgnumber.tips':'Enter SMS verification code',
    'page.user.forgetpassword.msgnumber.required':'Please enter SMS verification code',
    'page.user.forgetpassword.countdown.tips':'resend in seconds',
    'page.user.forgetpassword.newpassword.tips':'Set new password',
    'page.user.forgetpassword.newpassword.required':'Please input a password',
    'page.user.forgetpassword.confirmpassword.tips':'Confirm new password',
    'page.user.forgetpassword.confirmpassword.required':'Enter the password again',
    'page.user.forgetpassword.confirmpassword.required.compare':'The two passwords are inconsistent',
    'page.user.forgetpassword.phonecode.errormsg':'Failed to get graphic verification code!',
    'page.user.forgetpassword.smscode.errormsg':'SMS sending failed!',
    'page.user.forgetpassword.smscode.msg':'The SMS has been sent. Please check the verification code!',
    'page.user.forgetpassword.email.msg':'The email was sent successfully. Please log in to the mailbox for verification as soon as possible!',
    'page.user.forgetpassword.email.errormsg':'Failed to send mail!',
    'page.user.forgetpassword.phone.msg':'Password retrieved successfully!',
    'page.user.forgetpassword.phone.errormsg':'Password retrieval failed!',
}
